export const RECORDING_ANNOUNCEMENT_STORAGE_KEY = 'recordingAnnouncementShown';

export const RECORDING_ANNOUNCEMENT_HOME_ANCHOR = 'recording-announcement-home';

export const RECORDING_ANNOUNCEMENT_HOME_SELECTOR = `[data-spotlight-anchor="${RECORDING_ANNOUNCEMENT_HOME_ANCHOR}"]`;

export const RECORDING_RELEASE_DATE = '2026-10-05T00:00:00Z';
